import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=263207a7&scoped=true&"
import script from "./parameters.vue?vue&type=script&lang=js&"
export * from "./parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263207a7",
  null
  
)

export default component.exports